module.exports = __webpack_public_path__ + "static/media/equifax.0998092d.svg";